module.exports = __webpack_public_path__ + "img/leadProcessed.acc848e9.svg";